// @ts-nocheck
import React, { lazy } from 'react';
import { Dialog, DialogSuspense } from '@/components';
import withDialogRedux from '@/components/DialogReduxConnect';
import { compose } from '@/utils';

const ShipmentAddressDialogContent = lazy(() =>
  import('./ShipmentAddressDialogContent'),
);

function ShipmentAddressDialog({ dialogName, payload = {}, isOpen }) {
  return (
    <Dialog
      name={dialogName}
      className="dialog--shipment-address"
      isOpen={isOpen}
      autoFocus
      canEscapeKeyClose
      style={{ width: '760px' }}
    >
      <DialogSuspense>
        <ShipmentAddressDialogContent
          dialogName={dialogName}
          payload={payload}
        />
      </DialogSuspense>
    </Dialog>
  );
}

export default compose(withDialogRedux())(ShipmentAddressDialog);
